import { fromJS } from 'immutable'
import { createStore, compose, applyMiddleware } from 'redux'
import createMiddleware from './middleware'
import { makeRootReducer } from './reducers'

export default (initialState = {}, history) => {
  const enhancers = [
    applyMiddleware(...createMiddleware(history))
  ]

  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      name: "Drift Web App",
      actionsBlacklist: [
        '@@app/presence/SET_BUFFERED_USERS',
        '@@app/presence/ADD_USER_PROCESSED',
        '@@app/presence/REMOVE_USER_PROCESSED',
        '@@app/presence/REMOVE_USER_PROCESSED_DELAYED',
      ],
    }) : compose

  const store = createStore(
    makeRootReducer(),
    fromJS(initialState),
    composeEnhancers(...enhancers),
  )

  store.asyncReducers = {}

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/scripts/store/index.js